// import './gradientline.scss'

function init() {
// delete this
    console.log("hell0 gradient line");
// pull from codepen - but this isjust how it worked with scroll trigger

// Function to be called when the user enters the target element
// const line = document.querySelector(".line");

/*
what we want to do is apply classes that represent the colours 
we want to go to?

*/

// function handleIntersection(entries, observer) {
//   entries.forEach(entry => {
//     if (entry.isIntersecting) {

//       if (line.classList.contains("idle"))        {
//         line.classList.remove("idle");
//         line.classList.add("active");

//       } else{
//         line.classList.add("active");

//       }
//       console.log("User has reached the bottom of the  div.");
//     } else {

      
//       line.classList.remove("active");
//       line.classList.add("idle");

//       console.log("User has left the 'Content' div.");
//     }
//   });
// }

// // Options for the Intersection Observer
// const options = {
//   // root:null, ///'#container', // Use the viewport as the root
//   // rootMargin: '0px',
//   threshold: 0.2, // 1 = Trigger when the entire target is in the viewport
// };

// // Create an Intersection Observer
// const observer = new IntersectionObserver(handleIntersection, options);

// // Observe the target element
// const contentDiv = document.getElementById('content');
// observer.observe(contentDiv);



}

export default init